import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cohrex-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputComponent {
  private _startIcon?: string;
  @Input()
  set startIcon(value: string | undefined) {
    this._startIcon = value;
  }
  get startIcon(): string | undefined {
    return this._startIcon;
  }

  private _endIcon?: string;
  @Input()
  set endIcon(value: string | undefined) {
    this._endIcon = value;
  }
  get endIcon(): string | undefined {
    return this._endIcon;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }
  get isError(): boolean | undefined {
    return this._isError;
  }

  private _disabled?: boolean = false;
  @Input()
  set disabled(value: boolean | undefined) {
    this._disabled = value;
  }
  get disabled(): boolean | undefined {
    return this._disabled;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  private _type?: string = 'text';
  @Input()
  set type(value: string | undefined) {
    this._type = value;
  }
  get type(): string | undefined {
    return this._type;
  }

  private _min?: string = '';
  @Input()
  set min(value: string | undefined) {
    this._min = value;
  }
  get min(): string | undefined {
    return this._min;
  }

  private _max?: string = 'text';
  @Input()
  set max(value: string | undefined) {
    this._max = value;
  }
  get max(): string | undefined {
    return this._max;
  }

  @Input() width: string = 'tw-w-full';
  @Input() placeholder: string = '';
  @Input() label: string = '';
}
